import type { ReactNode } from "react";
import { CircularProgress, Grid } from "@mui/material";

export function LoadingScreen(): ReactNode {
  return (
    <Grid container sx={{ flexGrow: 1 }} justifyContent="center">
      <Grid sx={{ marginY: "20vh" }}>
        <CircularProgress size="15vh" />
      </Grid>
    </Grid>
  );
}
